module.exports = __webpack_public_path__ + "static/media/lv_ru_mob_s.cc7256d8.png";